/**
 * #580 D1 (#903) — the family-turn generations this tab put back on the locked picker.
 *
 * The turn's return (`state/ChildActorReturn.jsx`) sends no deactivate, so the server can still hold a
 * generation the screen retired: a renewal it saved whose answer was lost moved its deadline on. A session
 * read that still names that generation as active must not bring the child back without a PIN
 * (`api/session.js` `familyTurnAnswer`). A new selection is a new generation, and is never held back.
 *
 * Kept in this page's memory, and in `sessionStorage` so a reload of the same tab still sees it. Storage may be
 * missing, full, or stop answering later: memory still holds it for this page. The last few only. No imports,
 * so the session reader can use it without importing the turn's interactions, which import the session reader.
 */
const KEY = 'chorestory.familyTurn.retired';
const KEEP = 8;

/** What this page retired, whatever storage did with it. */
let retired = [];

function stored() {
  try {
    const list = JSON.parse(window.sessionStorage.getItem(KEY));
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

const keep = (list, generation) => [...list.filter((g) => g !== generation), generation].slice(-KEEP);

/** The device returned to the picker for the turn `generation`. */
export function retireFamilyGeneration(generation) {
  if (typeof generation !== 'string' || !generation) return;
  retired = keep(retired, generation);
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(keep(stored(), generation)));
  } catch {
    // Missing or full: memory still holds it.
  }
}

export function isFamilyGenerationRetired(generation) {
  return typeof generation === 'string' && (retired.includes(generation) || stored().includes(generation));
}

/** For tests only, never product code: forget what this page retired, as a reload does. Storage keeps its own. */
export function forgetRetiredFamilyGenerations() {
  retired = [];
}
